module.exports = new __parcel__URL__("controls.bb5a8133.png").toString();